import { c as _c } from "react/compiler-runtime";
import { PaperClipIcon } from '@heroicons/react/24/solid';
import type { ClientUploadedFileData } from 'uploadthing/types';
import { UploadButton as UploadButtonComponent } from '@/frontend/design-system/actions/Attachments/uploadthing';
import { cn } from '@/frontend/utils';
import { showErrorToastWithContactFormLink } from '../../feedback/Toaster/ToasterError';
export enum UPLOAD_ENDPOINT {
  ATTACHMENT = 'attachmentUploader',
  PROFILE_PICTURE = 'profilePictureUploader',
  CV = 'cvUploader',
}
export function UploadFilesButton(t0) {
  const $ = _c(11);
  const {
    endpoint,
    setFiles,
    multiple: t1,
    disabled: t2,
    buttonText
  } = t0;
  const multiple = t1 === undefined ? true : t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("ut-button:text-nowrap ut-button:border ut-button:border-borderPrimary ut-button:bg-backgroundPrimary ut-button:text-contentPrimary", "ut-button:hover:bg-backgroundHoverOverlay focus:ut-button:ring-algonavy-400 ut-button:focus:ring-2 ut-button:focus:ring-offset-2 ut-button:focus:ring-offset-white", "ut-button:w-40 ut-button:rounded-md ut-button:shadow-sm", "[&_[data-ut-element=\"allowed-content\"]]:hidden");
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== buttonText) {
    t4 = {
      button(t5) {
        const {
          ready
        } = t5;
        return <div className="flex flex-row items-center gap-3"><PaperClipIcon className="h-4 w-4" /><p className="select-none font-medium text-contentPrimary text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50">{ready ? buttonText ?? "Dodaj za\u0142\u0105czniki" : "\u0141adowanie..."}</p></div>;
      }
    };
    $[1] = buttonText;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== multiple || $[4] !== setFiles) {
    t5 = res => {
      if (multiple) {
        setFiles(res);
      } else {
        setFiles(res.slice(0, 1));
      }
    };
    $[3] = multiple;
    $[4] = setFiles;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== disabled || $[7] !== endpoint || $[8] !== t4 || $[9] !== t5) {
    t6 = <UploadButtonComponent className={t3} content={t4} endpoint={endpoint} onClientUploadComplete={t5} onUploadError={_temp} disabled={disabled} />;
    $[6] = disabled;
    $[7] = endpoint;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp() {
  showErrorToastWithContactFormLink();
}